module.exports = __webpack_public_path__ + "static/media/small-banner-welcome.951664d8.png";